function aiStockErrorText(err: unknown): string {
  const raw = err instanceof Error ? err.message : String(err ?? "");
  return raw
    .replace(/\s*\(\s*HTTP\s*\d{3}\s*\)/gi, "")
    .replace(/\bHTTP\s*\d{3}\b/gi, "")
    .replace(/\s{2,}/g, " ")
    .trim();
}

/** Erros em que o usuário pode tentar outra foto na mesma sessão. */
export function aiStockErrorIsRecoverable(err: unknown): boolean {
  const lower = aiStockErrorText(err).toLowerCase();
  if (lower.includes("limite diário")) return false;
  if (lower.includes("expirad")) return false;
  if (lower.includes("já foi utilizado")) return false;
  if (lower.includes("sessão inválida") || lower.includes("link inválido")) return false;
  if (lower.includes("sessão não encontrada")) return false;
  if (lower.includes("não configurada")) return false;
  return true;
}

/** Mensagem amigável para avisos da captura por IA. O erro técnico fica só no console. */
export function aiStockUserMessage(err: unknown): string {
  const stripped = aiStockErrorText(err);

  const lower = stripped.toLowerCase();

  if (lower.includes("nenhum item encontrado")) {
    return "Nenhum item encontrado na imagem. Tente outra foto.";
  }
  console.error("[ai-stock]", err);
  if (lower.includes("limite diário")) {
    return "Limite diário de leituras por IA atingido. Tente novamente amanhã.";
  }
  if (
    lower.includes("limite temporário") ||
    lower.includes("quota") ||
    lower.includes("rate limit") ||
    lower.includes("rate-limit")
  ) {
    return "O serviço de leitura por IA atingiu o limite temporário. Tente novamente mais tarde.";
  }

  if (
    /exception|stack trace|\/api\/|\.php\b|sqlstate|undefined|etypeerror|syntaxerror|\{|\}/i.test(
      stripped,
    )
  ) {
    return "Não foi possível processar a imagem. Tente novamente.";
  }

  if (stripped && stripped.length > 0 && stripped.length <= 180) {
    return stripped;
  }

  return "Não foi possível processar a imagem. Tente novamente.";
}
